import React from 'react';
import Link from 'components/react-styled-core/Link';

export default ({ children, href = '#', ...props }) => (
    <Link
        display="inline"
        color="blue:80"
        _hover={{
            color: 'red:80',
            textDecoration: 'underline',
        }}
        _visited={{
            color: 'blue:80',
        }}
        target="_blank"
        href={href}
        {...props}
    >
        {children}
    </Link>
);
